import posthog from 'posthog-js'

const posthogKey = process.env.GATSBY_POSTHOG_KEY
const posthogHost = process.env.GATSBY_POSTHOG_HOST

if (typeof window !== 'undefined') {
  if (!posthogKey) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(
        '[PostHog] GATSBY_POSTHOG_KEY is missing. Analytics will be disabled until configured.',
      )
    }
  } else if (!posthogHost) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(
        '[PostHog] GATSBY_POSTHOG_HOST is missing. Analytics will be disabled until configured.',
      )
    }
  } else {
    posthog.init(posthogKey, {
      api_host: posthogHost,
      persistence: 'memory',
    })
    posthog.startExceptionAutocapture({
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false,
    })
  }
}

export default posthog
